var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinads(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.6667 51.3333H41.9616V34.5898C41.9616 30.2072 40.1306 27.2153 36.1044 27.2153C33.0248 27.2153 31.3121 29.2343 30.515 31.1801C30.2161 31.8785 30.2628 32.8514 30.2628 33.8243V51.3333H18.6667C18.6667 51.3333 18.8161 21.6738 18.6667 18.9778H30.2628V24.0557C30.9478 21.8354 34.6533 18.6667 40.5666 18.6667C47.9029 18.6667 53.6667 23.3207 53.6667 33.3424V51.3333ZM8.13768 16.3333H8.0681C4.58898 16.3333 2.33334 13.7629 2.33334 10.5048C2.33334 7.1832 4.65566 4.66667 8.20437 4.66667C11.7502 4.66667 13.9304 7.17686 14 10.4953C14 13.7534 11.7502 16.3333 8.13768 16.3333ZM4.66668 18.6667H14V51.3333H4.66668V18.6667Z",
    fill: "#9CA3AF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinads);
export default __webpack_public_path__ + "static/media/linkedinads.8df753ee0cf4087c9819ff66c38113cf.svg";
export { ForwardRef as ReactComponent };